import styled from "styled-components"
import { Link as gatsbyLink } from "gatsby"

export const Link = styled(gatsbyLink)`
  color: inherit;
`
